<template>
  <b-card>
    <div
      class="p-3"
      v-for="sentence in sentences"
      :key="sentence.sentenceId"
    >
      <b-badge pill variant="secondary">No.{{ sentence.number }}</b-badge>
      <b-button
        v-b-toggle="`collapse-${sentence.sentenceId}`"
        :variant="sentence.visible ? 'primary' : 'outline-primary'"
        size="sm"
        class="m-4"
        @click="sentence.visible = !sentence.visible"
      >
        <i :class="sentence.visible ? 'fa-regular fa-folder-closed' : 'fa-regular fa-folder-open'"></i>
        {{ sentence.visible ? 'Hide' : 'Show' }} translation
      </b-button>
      <div class="m-3">
        <span v-for="word in sentence.words" :key="word.wordId">
          <b-link
            class="word"
            :id="`popover-${sentence.sentenceId}-${word.wordId}`"
          >
            {{ word.vocabulary }}
          </b-link>
          <b-popover
            custom-class="auto-width-popover"
            v-if="word.title"
            :target="`popover-${sentence.sentenceId}-${word.wordId}`"
            variant="secondary"
            triggers="hover focus"
            placement="top"
          >
            <template v-slot:title>
              <span v-html="word.title"></span>
            </template>
            <span v-html="word.content"></span>
          </b-popover>
        </span>
      </div>
      <div v-if="sentence.pronounceUrl">
        <audio controls>
          <source :src="domainUrl(sentence.pronounceUrl)" type="audio/ogg" />
          <source :src="domainUrl(sentence.pronounceUrl)" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
      <b-collapse :id="`collapse-${sentence.sentenceId}`">
        <b-card>{{ sentence.translation }}</b-card>
      </b-collapse>
    </div>
  </b-card>
</template>

<script>
  export default {
    name: "SentenceView",
    props: {
      sentences: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      domain() {
        return process.env.VUE_APP_S3_DOMAIN || '';
      }
    },
    methods: {
      domainUrl(path) {
        return `${this.domain}${path}`;
      }
    }
  }
</script>

<style scoped>
.word {
  font-size:20px;
  /* font-family:Arial; */
}
</style>

